import React, { FC, MouseEventHandler } from 'react';
import { Link } from 'react-router-dom';

import { IconName } from '../../assets';
import Icon from '../../assets/Icon';
import Spinner from '../spinner/spinner';

import './Button.scss';

export enum Theme {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SECONDARY_TRANSPARENT = 'secondary-transparent',
  INVERSE = 'inverse',
  TRANSPARANT = 'transparant',
  DESTRUCTIVE = 'destructive',
  INVERSE_DESTRUCTIVE = 'inverse-destructive',
  PLAIN = 'plain',
}

interface Props {
  link?: string;
  ahref?: string;
  theme?: Theme;
  icon?: IconName;
  onClickCallback?: MouseEventHandler<HTMLElement>;
  isLoading?: boolean;
  isDisabled?: boolean;
  className?: string;
  wide?: boolean;
  tooltip?: string;
}

const Button: FC<Props> = ({
  link,
  children,
  ahref,
  theme = Theme.PLAIN,
  icon,
  onClickCallback = () => {},
  isLoading = false,
  isDisabled = false,
  className = '',
  wide = false,
  tooltip,
}) => {
  const renderClickPart = (cssClasses: string) => {
    if (link) {
      return (
        <Link className={cssClasses} to={link}>
          <div className='btn-content'>
            <Icon name={icon} />
            {children}
          </div>
        </Link>
      );
    } else if (ahref) {
      return (
        <a href={ahref} className={cssClasses}>
          <div className='btn-content'>
            <Icon name={icon} />
            {children}
          </div>
        </a>
      );
    }
    return (
      <button onClick={onClickCallback} className={cssClasses} disabled={isDisabled} title={tooltip}>
        <div className={`btn-content ${isLoading ? 'btn-loading' : ''}`}>
          <Icon name={icon} />
          {children}
        </div>
        {isLoading && <Spinner />}
      </button>
    );
  };
  return renderClickPart(`btn btn-${theme} ${className} ${!!children ? '' : 'btn-without-label'} ${wide ? 'btn-wide' : ''}`);
};

export default Button;
